






























import { PlanosService, TipoPlano } from "@/services/planos.service";
import { Prop, Vue, Component, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value: number;
}

@Component
export default class ComboPlanos extends Vue {
  @Prop() readonly value!: TipoPlano[] | null;
  @Prop() readonly rules!: undefined;
  loading = false;
  icone = "mdi-checkbox-blank-outline";
  cor = "";
  selectedItens: TipoPlano[] = [];
  items: TipoPlano[] = [];
  @Watch("selectedItens")
  onChange() {
    this.$emit("input", this.selectedItens);
  }
  async fetchTipos() {
    this.loading = true;
    this.items = await PlanosService.listarTiposAtivosNaoGratuitos();
    this.loading = false;
  }

  async mounted() {
    await this.fetchTipos();
    this.computeSelected();
  }
  computeSelected() {
    if (this.value) {
      this.selectedItens = this.value;
    }
  }
  toggle() {
    this.$nextTick(() => {
      if (this.selectedItens.length > 0) {
        this.selectedItens = [];
        this.cor = "";
        this.icone = "mdi-checkbox-blank-outline";
      } else {
        this.selectedItens = this.items;
        this.cor = "indigo darken-4";
        this.icone = "mdi-close-box";
      }
    });
  }
}
